export default __webpack_public_path__ + "static/media/DharmaGothicE_Light_R.000b2f5d.otf";